
// Libraries
var React = require('react');

// Styles
require('./SiteLinks.scss');

class SiteLinksModule extends React.Component {
	render() {
		return (		
			<div className={"site-links"}>
				<div className={"site-links-wrapper"}>
					<ul>
						{this.props.data.links.map((item, index) => {	
							return(										
								<li key={index}>
									<a href={item.url} target={item.newWindow ? "_blank" : "_self"} rel={item.newWindow ? "noopener noreferrer" : undefined}>{item.caption}</a>
								</li>							
							);
						})}
					</ul>
				</div>
			</div>
		)
	}
}

module.exports = SiteLinksModule;


// WEBPACK FOOTER //
// ./src/components/Footer/SiteLinks/SiteLinksModule.js